export function mapDailyRowToSummaryRow(row, templateId) {
  const buttons = row?.cta_clicks_by_button ?? {};
  const sent = row?.messages_sent ?? 0;
  return {
    template_id: templateId ?? row?.template_id,
    sent_date: row?.date ?? row?.sent_date,
    total_users: sent,
    sent_count: sent,
    delivered_count: row?.messages_delivered ?? 0,
    read_count: row?.messages_read ?? 0,
    failed_count: row?.messages_failed ?? 0,
    unique_button_count: row?.unique_cta_clickers ?? 0,
    button_count_1: buttons.button_1 ?? 0,
    button_count_2: buttons.button_2 ?? 0,
    button_count_3: buttons.button_3 ?? 0,
  };
}

export function mapReportingDetailToMessageCounts(detail) {
  return {
    sent_count: detail?.messages_sent ?? 0,
    delivered_count: detail?.messages_delivered ?? 0,
    read_count: detail?.messages_read ?? 0,
    failed_count: detail?.messages_failed ?? 0,
    button_count_1: 0,
    button_count_2: 0,
    button_count_3: 0,
  };
}

export function resolveButtonLabel(row, index, template) {
  const fromApi = (row?.button_label || '').trim();
  if (fromApi) return fromApi;

  const buttonId = row?.button_id || '';
  const match = buttonId.match(/^button_(\d+)$/);
  if (match && template) {
    const buttons =
      template?.components?.find((component) => component?.type === 'BUTTONS')?.buttons ?? [];
    const btn = buttons[parseInt(match[1], 10) - 1];
    if (btn?.text) return btn.text;
    if (btn?.name) return btn.name;
  }

  return buttonId || `Button ${index + 1}`;
}

export function mapCtaRowsToButtonEngagement(ctaRows, detail, template) {
  const delivered = detail?.messages_delivered ?? 0;

  return (ctaRows ?? []).map((row, index) => {
    const clicks = row.total_clicks ?? 0;
    const clickRate =
      delivered > 0 ? `${((clicks / delivered) * 100).toFixed(2)}%` : '0%';
    return {
      label: resolveButtonLabel(row, index, template),
      type: 'Quick reply',
      totalClicks: clicks,
      clickRate,
    };
  });
}

export function buildReportingGraphFromDaily(dailyRows) {
  const list = dailyRows ?? [];
  if (!list.length) return null;

  return {
    series: [
      { data: list.map((item) => item.messages_sent || 0), label: 'Sent' },
      { data: list.map((item) => item.messages_delivered || 0), label: 'Delivered' },
      { data: list.map((item) => item.messages_read || 0), label: 'Read' },
    ],
    xAxis: [{ scaleType: 'point', data: list.map((item) => item.date || item.sent_date || 'N/A') }],
  };
}
